import { render, staticRenderFns } from "./showCode.vue?vue&type=template&id=ad63ec54&scoped=true"
import script from "./showCode.vue?vue&type=script&lang=js"
export * from "./showCode.vue?vue&type=script&lang=js"
import style0 from "./showCode.vue?vue&type=style&index=0&id=ad63ec54&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad63ec54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/web_acadmin_online_docker/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad63ec54')) {
      api.createRecord('ad63ec54', component.options)
    } else {
      api.reload('ad63ec54', component.options)
    }
    module.hot.accept("./showCode.vue?vue&type=template&id=ad63ec54&scoped=true", function () {
      api.rerender('ad63ec54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/template/components/components/showCode.vue"
export default component.exports